<template>
  <div class="comp-operation-filter">
    <div class="space-wrap">
      <jw-dropdown trigger="click" @select="operationUserDropdown" popup-container=".comp-operation-filter">
        <jw-button :class="['search-person', 'button-bg-bd', data.userInfo ? 'person-active' : '']" @mouseenter="showClose.person = true" @mouseleave="showClose.person = false">
          <template v-if="data.userInfo">
            <jw-space>
              <div class="avatar-box">
                <div class="box-mask"></div>
                <xl-avatar :hasCard="0" :avatar="{ name: data.userInfo?.userName || '', url: data.userInfo?.avatar, id: data.userInfo?.id }" :size="22" />
              </div>
              <span @click.stop="clearSearch(2)"><icon-close /></span>
            </jw-space>
          </template>
          <template v-else>
            <jw-space>
              <qfei-icon-user-outlined class="icon-person" />
              <span>操作人</span>
            </jw-space>
          </template>
        </jw-button>
        <template #content>
          <jw-doption :value="1">当前用户</jw-doption>
          <jw-doption :value="2">指定用户</jw-doption>
        </template>
      </jw-dropdown>
      <jw-dropdown :popup-visible="datePopupVisible" @select="dateDropwn" popup-container=".comp-operation-filter" class="date-dropdown">
        <jw-button @click="datePopupVisible = !datePopupVisible" @mouseenter="showClose.date = true" @mouseleave="showClose.date = false" :class="['search-date', 'button-bg-bd', data.dateInfo || data.customeDate ? 'date-active' : '']">
          <jw-space>
            <jw-tooltip content="操作日期">
              <!-- <span> -->
              <qfei-icon-date-range-outlined />
              <!-- <component :is="'QfIconRiqi'" /> -->
              <!-- </span> -->
            </jw-tooltip>

            <template v-if="data.dateInfo || data.customeDate">
              <template v-if="data.dateInfo">
                {{ data.dateInfo?.label }}
              </template>
              <template v-else-if="data.customeDate">
                <template v-if="Array.isArray(data.customeDate)">
                  <jw-tooltip :content="`${data.customeDate[0]} - ${data.customeDate[1]}`">
                    <span>自定义</span>
                  </jw-tooltip>
                </template>
                <template v-else> {{ data.customeDate }}</template>
              </template>
              <span @click.stop="clearSearch(1)"><icon-close /></span>
            </template>
          </jw-space>
        </jw-button>
        <template #content>
          <jw-dsubmenu :update-at-scroll="true" :content-class="{ 'date-operation-menu': true, 'operation-log-custom-active': dateActiveType == 7 }">
            <template #default><div :class="{ 'operation-log-custom-active': dateActiveType == 7 }">自定义</div></template>
            <template #suffix>
              <icon-right size="14" :style="{ color: dateActiveType == 7 ? 'rgb(var(--primary-6))' : 'var(--color-text-2)' }" />
            </template>
            <template #content>
              <div :value="7" style="width: 500px">
                <jw-range-picker v-model="data.customeDate" hide-trigger @change="chooseDate" :style="{ border: 'none' }" />
              </div>
            </template>
          </jw-dsubmenu>
          <jw-doption v-for="(item, index) in dateSelect" :class="{ 'is-active': item.value === dateActiveType }" :key="index" :value="item.value">{{ item.label }}</jw-doption>
        </template>
      </jw-dropdown>

      <div class="filter-select">
        <filter-inner :handleTypeList="handleSourceList" handleType="source" @cb="typeCb" />
      </div>
      <div class="filter-select">
        <filter-inner :handleTypeList="handleTypeList" handleType="type" @cb="typeCb" />
      </div>
      <div class="filter-select">
        <filter-inner :handleTypeList="allFields" handleType="fields" @cb="typeCb" />
      </div>
    </div>
    <xl-tree-member-modal ref="memberModalRef" :multipleDep="false" :tree="tree" @cb="getVal($event)" :user="data?.userList"> <span></span></xl-tree-member-modal>
    <teleport to=".drawer-min-width" v-if="datePopupVisible">
      <div class="search-mask" @click="datePopupVisible = false"></div>
    </teleport>
    <!-- <div class="search-mask" @click="datepopupVisible = false"></div> -->
  </div>
</template>
<script setup>
import { reactive, ref, computed } from 'vue';
import { useUserStore } from '@/store';
import FilterInner from '../filter-inner/index.vue';
const { userInfo } = useUserStore(); //当前用户信息
const emits = defineEmits(['cb']);
const props = defineProps({
  allFields: Array
});
console.log('获取所有字段2', props.allFields);

const memberModalRef = ref(null);
const datePopupVisible = ref(false);
const data = reactive({
  showUser: false,
  showTime: false,
  userInfo: null,
  dateInfo: null,
  customeDate: null,
  handleType: []
});
const showClose = reactive({
  person: false,
  date: false
});
const dateActiveType = ref();
const filterOptions = ref({
  operationUser: '', // 操作人
  operationDate: null, // 操作时间
  operationSource: null, // 操作来源
  operationType: null, // 操作类型
  operationFields: null // 操作字段
}); // 筛选参数
const dateSelect = ref([
  {
    label: '今天',
    value: 2
  },
  {
    label: '昨天',
    value: 3
  },
  {
    label: '本周',
    value: 8
  },
  {
    label: '上周',
    value: 9
  },
  {
    label: '本月',
    value: 11
  },
  {
    label: '上月',
    value: 12
  }
]);

// 操作来源
const handleSourceList = ref([
  {
    label: '用户',
    value: 1
  },
  {
    label: '自动化流程',
    value: 3
  },
  {
    label: '审批',
    value: 4
  },
  {
    label: 'SDK',
    value: 2
  }
]);

//操作类型
const handleTypeList = ref([
  {
    label: '新增',
    value: 1
  },
  {
    label: '修改',
    value: 2
  },
  {
    label: '删除',
    value: 3
  },
  {
    label: '批量修改',
    value: 4
  },
  {
    label: '批量删除',
    value: 5
  },
  {
    label: '导入新增',
    value: 6
  },
  {
    label: '导入修改',
    value: 7
  },
  {
    label: '计算字段',
    value: 8
  }
]);

const typeCb = (typeVal) => {
  const { type, data } = typeVal;

  const updateFilterOption = (key) => {
    console.log('数据不相同', filterOptions.value, key, data);
    filterOptions.value[key] = data.length ? data : null;
    emits('cb', filterOptions.value);
    // if (data?.join() !== filterOptions.value[key]?.join()) {
    // } else {
    //   console.log('数据相同');
    // }
  };

  const typeMap = {
    source: 'operationSource',
    type: 'operationType',
    fields: 'operationFields'
  };

  if (typeMap[type]) {
    updateFilterOption(typeMap[type]);
  }
};

// 清空搜索
const clearSearch = (clearType) => {
  console.log('清空搜索', clearType);
  if (clearType === 1) {
    // 清空日期
    data.dateInfo = null;
    data.customeDate = null;
    filterOptions.value.operationDate = null;
    showClose.date = false;
    dateActiveType.value = null;
  } else if (clearType === 2) {
    data.userInfo = null;
    filterOptions.value.operationUser = null;
    showClose.person = false;
  }
  emits('cb', filterOptions.value);
};

const getVal = (v) => {
  const userNames = computed(() =>
    v?.userList?.map((u) => {
      return {
        avatar: u.avatarOrigin,
        ...u
      };
    })
  );
  data.showUser = true;
  data.userInfo = userNames.value[0];
  filterOptions.value.operationUser = data.userInfo.id;
  emits('cb', filterOptions.value);
};

// 人员下拉
const operationUserDropdown = (v) => {
  if (v === 1) {
    // 当前用户
    data.showUser = true;
    data.userInfo = userInfo;
    data.userInfo.avatar = userInfo.avatarOrigin;
    filterOptions.value.operationUser = userInfo.id;
    emits('cb', filterOptions.value);
  }
  if (v === 2) {
    // 指定用户
    memberModalRef.value.openDialog();
  }
};
// 日期下拉
const dateDropwn = (v) => {
  if (v !== 7) {
    // 非自定义日期
    const selectDate = dateSelect.value.find((item) => item.value === v);
    data.dateInfo = selectDate;
    datePopupVisible.value = false;
    dateActiveType.value = v;
    filterOptions.value.operationDate = JSON.stringify({
      type: v,
      value: null
    });
    emits('cb', filterOptions.value);
  }
};

//选择日期
const chooseDate = (v) => {
  console.log('选择日期', v);
  data.dateInfo = null;
  data.customeDate = v;
  dateActiveType.value = 7;
  datePopupVisible.value = false;
  filterOptions.value.operationDate = JSON.stringify({
    type: 7,
    value: {
      beginDate: v[0],
      endDate: v[1]
    },
    dateVariable: v
  });

  emits('cb', filterOptions.value);
};

const name = ref();
console.log(data);
console.log(name);
const tree = ref({
  isAll: true
});
</script>
<style scoped lang="less">
@import './index.less';
</style>
